import React from "react";
import { Link } from "react-router-dom";
import { analytics } from "../../../analytics";
import { convertToSlug, assurePrefix } from "../../../util/commonFunctions";

const SponsoredContentComponent = ({ sponsoredBy }) => {
  console.log("Sponsored By Component:", sponsoredBy);
  if (!sponsoredBy) {
    return null;
  }

  return sponsoredBy.target && sponsoredBy.mediaDetail && sponsoredBy.target.toLowerCase() == "media" ? (
    <Link
      className="col-sm-12 sponsoredPad"
      to={
        "/media/" +
        convertToSlug(sponsoredBy.mediaDetail.title) +
        "?videoId=" +
        sponsoredBy.mediaDetail.id
      }
      onClick={() =>
        analytics("cta_clicked", {
          id: sponsoredBy.id,
          subject: sponsoredBy.subject,
          sub_heading: sponsoredBy?.subHeading || "",
          heading: sponsoredBy.heading
        })
      }
    >
      <div className="row align-items-center">
        <div className="col-6 col-sm-4 col-md-5 col-lg-3 no-gutter-col">
          <img className="img-fluid" src={sponsoredBy.ctaImageUrl} />
        </div>
        <div className="col-6 col-sm-8 col-md-7 col-lg-9 no-gutter-col">
          <div className="sponsored_content">
            <span>{sponsoredBy.subject}</span>
            <h4>{sponsoredBy.heading}</h4>
            {sponsoredBy?.description && <p>{sponsoredBy?.description}</p>}
            {sponsoredBy?.subHeading && <span className="topic">{sponsoredBy?.subHeading}</span>}
          </div>
        </div>
      </div>
    </Link>
  ) : sponsoredBy.target ? (
    <a
      className="col-sm-12 sponsoredPad"
      href={assurePrefix(sponsoredBy.externalLinkUrl)}
      onClick={() =>
        analytics("cta_clicked", {
          id: sponsoredBy.id,
          subject: sponsoredBy.subject,
          sub_heading: sponsoredBy?.subHeading || "",
          heading: sponsoredBy.heading
        })
      }
      target="_blank"
    >
      <div className="row align-items-center">
        <div className="col-6 col-sm-4 col-md-5 col-lg-3 no-gutter-col">
          <img className="img-fluid" src={sponsoredBy.ctaImageUrl} />
        </div>
        <div className="col-6 col-sm-8 col-md-7 col-lg-9 no-gutter-col">
          <div className="sponsored_content">
            <span>{sponsoredBy.subject}</span>
            <h4>{sponsoredBy.heading}</h4>
            {sponsoredBy?.description && <p>{sponsoredBy?.description}</p>}
            {sponsoredBy?.subHeading && <span className="topic">{sponsoredBy?.subHeading}</span>}
          </div>
        </div>
      </div>
    </a>
  ) : (
    ""
  );
};

export { SponsoredContentComponent };
